"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gsap = require("gsap");

var _isEqual = require("lodash/isEqual");

var _isEqual2 = _interopRequireDefault(_isEqual);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Title = function (_Component) {
    _inherits(Title, _Component);

    function Title(props) {
        _classCallCheck(this, Title);

        var _this = _possibleConstructorReturn(this, (Title.__proto__ || Object.getPrototypeOf(Title)).call(this, props));

        _this.recalculate = function () {
            var bboxs = _this.texts.map(function (text) {
                return text.getBBox();
            });

            var _this$getScalesAndGap = _this.getScalesAndGaps(bboxs),
                scales = _this$getScalesAndGap.scales,
                gaps = _this$getScalesAndGap.gaps;

            _this.setState({ scales: scales, gaps: gaps });
        };

        _this.animate = function () {
            var gaps = _this.state.gaps;
            var scales = _this.state.scales;
            var ease = _gsap.Power3.easeOut;

            _this.timeline = new _gsap.TimelineMax({ paused: true, onReverseComplete: _this.handleRest });

            _this.timeline.from(_this.rects[0], 0.5, { scaleX: 0, transformOrigin: "center" }).fromTo(_this.texts[1], 0.5, { scale: scales[1],
                x: _this.props.size / 2,
                y: gaps[1] * 3 + _this.barWidth,
                transformOrigin: "center"
            }, { y: gaps[1] }, "-=0.3").fromTo(_this.texts[0], 0.5, {
                scale: scales[0],
                x: _this.props.size,
                y: gaps[1] * 2 + gaps[0] + _this.barWidth,
                transformOrigin: "center"
            }, { x: _this.props.size / 2, ease: ease }, "-=0.2").fromTo(_this.texts[2], 0.5, {
                scale: scales[0],
                x: 0,
                y: gaps[1] * 2 + gaps[0] + _this.barWidth,
                transformOrigin: "center"
            }, { x: _this.props.size / 2, ease: ease }, "-=0.5");
        };

        _this.handleRest = function () {
            var onComplete = _this.props.onComplete;

            _this.setState({ close: true });
            if (onComplete) onComplete(_this.state.open);
        };

        _this.getScalesAndGaps = function (bboxs) {
            return bboxs.reduce(function (_ref, _ref2) {
                var scales = _ref.scales,
                    gaps = _ref.gaps;
                var _ref2$width = _ref2.width,
                    width = _ref2$width === undefined ? 0 : _ref2$width,
                    _ref2$height = _ref2.height,
                    height = _ref2$height === undefined ? 0 : _ref2$height;

                var scale = width ? _this.props.size * 0.9 / width : 1;
                var gap = height * 0.75 * scale / 2;

                return {
                    scales: [].concat(_toConsumableArray(scales), [scale]),
                    gaps: [].concat(_toConsumableArray(gaps), [gap])
                };
            }, { scales: [], gaps: [] });
        };

        var _this$props = _this.props,
            text1 = _this$props.text1,
            text2 = _this$props.text2,
            open = _this$props.open;


        _this.texts = [];
        _this.rects = [];

        _this.state = {
            scales: [0, 0],
            gaps: [0, 0],
            open: open,
            close: !open,
            texts: [text1, text2]
        };

        var barWidth = 2.5;

        _this.barWidth = Math.ceil(_this.props.size * barWidth / 100);

        _this.timeline = null;
        _this.isFirefox = typeof InstallTrigger !== "undefined";
        return _this;
    }

    _createClass(Title, [{
        key: "shouldComponentUpdate",
        value: function shouldComponentUpdate(nextProps, _ref3) {
            var open = _ref3.open,
                texts = _ref3.texts,
                scales = _ref3.scales,
                close = _ref3.close;

            return open !== this.state.open || close !== this.state.close || !(0, _isEqual2.default)(this.state.scales, scales) || !(0, _isEqual2.default)(this.state.texts, texts);
        }
    }, {
        key: "componentDidMount",
        value: function componentDidMount() {
            this.recalculate();
        }
    }, {
        key: "componentDidUpdate",
        value: function componentDidUpdate(prevProps, _ref4) {
            var pOpen = _ref4.open,
                wasClosed = _ref4.close,
                pScales = _ref4.scales,
                texts = _ref4.texts;
            var _state = this.state,
                scales = _state.scales,
                close = _state.close,
                open = _state.open;


            if (!(0, _isEqual2.default)(scales, pScales) || wasClosed) {
                if (this.timeline) this.timeline.kill();
                this.animate();
            }

            if (!(0, _isEqual2.default)(scales, pScales) || open !== pOpen) {
                if (open) this.timeline.play();else this.timeline.reverse();
            }

            if (!close && !(0, _isEqual2.default)(this.state.texts, texts)) this.recalculate();
        }
    }, {
        key: "render",
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                size = _props.size,
                style = _props.style;

            var center = size / 2;
            var _state2 = this.state,
                texts = _state2.texts,
                gaps = _state2.gaps,
                close = _state2.close;

            var height = Math.min((gaps[1] + gaps[0]) * 2 + 10, size);

            return !close && _react2.default.createElement(
                "svg",
                { width: size, height: height, style: style },
                _react2.default.createElement(
                    "defs",
                    null,
                    _react2.default.createElement(
                        "clipPath",
                        { id: "clip1" },
                        _react2.default.createElement("rect", {
                            ref: function ref(el) {
                                return _this2.rects[2] = el;
                            },
                            width: size,
                            height: gaps[1] * 2
                        })
                    ),
                    _react2.default.createElement(
                        "clipPath",
                        { id: "clip2" },
                        _react2.default.createElement("rect", { x: "0", y: gaps[1] * 2 + this.barWidth, width: center, height: gaps[0] * 2 })
                    ),
                    _react2.default.createElement(
                        "clipPath",
                        { id: "clip3" },
                        _react2.default.createElement("rect", { x: center, y: gaps[1] * 2 + this.barWidth, width: center, height: gaps[0] * 2 })
                    )
                ),
                _react2.default.createElement(
                    "g",
                    { clipPath: "url(#clip2)" },
                    _react2.default.createElement(
                        "text",
                        {
                            id: "text-1",
                            ref: function ref(el) {
                                return _this2.texts[0] = el;
                            },
                            fill: "black",
                            fontWeight: "bold",
                            textAnchor: "middle",
                            alignmentBaseline: "central" // vertical centering in firefox
                            , dominantBaseline: "central" },
                        texts[0]
                    )
                ),
                _react2.default.createElement(
                    "g",
                    { clipPath: "url(#clip3)" },
                    _react2.default.createElement(
                        "text",
                        {
                            id: "text-3",
                            ref: function ref(el) {
                                return _this2.texts[2] = el;
                            },
                            fill: "black",
                            fontWeight: "bold",
                            textAnchor: "middle",
                            alignmentBaseline: "central" // vertical centering in firefox
                            , dominantBaseline: "central" },
                        texts[0]
                    )
                ),
                _react2.default.createElement(
                    "g",
                    { clipPath: "url(#clip1)" },
                    this.isFirefox && _react2.default.createElement("rect", { x: "0", y: "0", width: "100%", height: "100%", fill: "transparent" }),
                    _react2.default.createElement(
                        "text",
                        {
                            id: "text-2",
                            ref: function ref(el) {
                                return _this2.texts[1] = el;
                            },
                            fill: "black",
                            alignmentBaseline: "central",
                            dominantBaseline: "central" // vertical centering in firefox
                            , fontWeight: "bold",
                            textAnchor: "middle" },
                        texts[1]
                    )
                ),
                _react2.default.createElement("rect", {
                    y: gaps[1] * 2,
                    ref: function ref(el) {
                        return _this2.rects[0] = el;
                    },
                    width: size,
                    height: this.barWidth,
                    fill: "white"
                })
            );
        }
    }], [{
        key: "getDerivedStateFromProps",
        value: function getDerivedStateFromProps(_ref5, _ref6) {
            var open = _ref5.open,
                text1 = _ref5.text1,
                text2 = _ref5.text2;
            var prevOpen = _ref6.open,
                texts = _ref6.texts;

            if (open !== prevOpen) return { open: open, close: false };
            if (!(0, _isEqual2.default)([text1, text2], texts)) return { texts: [text1, text2] };

            return null;
        }
    }]);

    return Title;
}(_react.Component);

Title.propTypes = {
    text1: _propTypes2.default.string,
    text2: _propTypes2.default.string,
    size: _propTypes2.default.number
};
exports.default = Title;
